@import 'styles/mixins';
@import 'styles/variables';

.actions {
  display: flex;
  padding: 10px var(--side-padding) 10px var(--side-padding);
  gap: 8px;
  flex-wrap: wrap;

  @include for-phone-only {
    flex-direction: column;
    padding: 0;
  }
}
